"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToOutOfAreaFormProps({ data }) {
    return {
        submissionUrl: data?.submissionUrl,
        fields: [
            {
                type: 'text',
                name: 'firstName',
                label: 'First Name'
            },
            {
                type: 'text',
                name: 'lastName',
                label: 'Last Name'
            },
            {
                type: 'email',
                name: 'email',
                label: 'Email'
            },
        ],
    };
}
exports.default = mapToOutOfAreaFormProps;
